export type Product = {
    name: string;
    price: string;
    image: string;
}
export type FunnelData = {
    id: string;
    number: string;
    name: string;
    mainProduct: Product;
    orderBump?: Product;
    upsell?: Product;
    totalProducts: number;
  };
  
  export type BrandData = {
    name: string;
    context: string;
  };
  
  export type OnboardingData = {
    step: number;
    selectedFunnels: FunnelData[];
    brandData: BrandData;
  };
  
  export const mockFunnels: FunnelData[] = [
    {
      id: '1',
      number: '5',
      name: 'Clicksmith',
      mainProduct: {
        // name: 'Mouse Gamer Inalámbrico E-YOOSO',
        name: 'E-YOOSO Gaming Mouse, Tri-Modes Wireless/Bluetooth/Wired Rechargeable RGB Gamer Mouse with 2 Side Buttons, Rapid Fire Key, 8000 DPI, 6 Backlit Modes, 9 Programmable Buttons Macro',
        price: '79900',
        image: 'https://fluxi.co/dev/assets/752c08e9beab4bfba2c6198d027fe3f/products/variations/ac2f610e/variation_9ac3faa5.webp'
      },
      orderBump: {
        name: 'Japanese Sea Wave Large Mouse Pad, Anime Black Gaming, Extended Kanagawa Mat Desk Pad, 3mm Thick Long Non-Slip Rubber Base Mice Pad, 31.5 X 11.8 Inch',
        price: '29900',
        image: 'https://m.media-amazon.com/images/I/71HnS4gBdhL._AC_SL1500_.jpg'
      },
      upsell: {
        name: 'Bloomoak-99% Blue Green Light Blocking Glasses - Gaming Glasses - Anti Glare - Anti Fatigue -Suitable for Screens, Games, TVs',
        price: '59900',
        image: 'https://m.media-amazon.com/images/I/51EDso+bKSL._AC_SL1500_.jpg'
      },
      totalProducts: 3
    },
  ];